/**
 * Tooltip: navy.800, white 0.75rem 600, radius md.
 * Chakra only reads variant/size/colorScheme from theme defaultProps, so pass `hasArrow openDelay={300}` at call sites.
 */
export const Tooltip = {
  baseStyle: {
    bg: "navy.800",
    color: "white",
    fontSize: "0.75rem",
    fontWeight: 600,
    px: 3,
    py: 2,
    borderRadius: "md",
    boxShadow: "lg",
    "--popper-arrow-bg": "#1B1F5E",
    maxW: "20rem",
  },
};
